import React from 'react'
import { ColourLabel } from '../../general/ColourLabel'

export interface IHexColourCell {
  content: string
}

export const HexColourCell: React.FC<IHexColourCell> = props => <ColourLabel colour={props.content} />

export default React.memo(HexColourCell)
